import React from 'react'
import { Image } from 'rebass/styled-components'

const ImageLoader = () => {
    return (
        <Image
            alt=""
            decoding="async"
            loading="eager"
            role="presentation"
            src={`data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 1080 "%3E%3C/svg%3E`}
        />
    )
}

export default ImageLoader
